var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMore(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.5 7.93188C13.6 7.93188 14.5 7.03188 14.5 5.93188C14.5 4.83188 13.6 3.93188 12.5 3.93188C11.4 3.93188 10.5 4.83188 10.5 5.93188C10.5 7.03188 11.4 7.93188 12.5 7.93188ZM12.5 10.9319C11.4 10.9319 10.5 11.8319 10.5 12.9319C10.5 14.0319 11.4 14.9319 12.5 14.9319C13.6 14.9319 14.5 14.0319 14.5 12.9319C14.5 11.8319 13.6 10.9319 12.5 10.9319ZM10.5 19.9319C10.5 18.8319 11.4 17.9319 12.5 17.9319C13.6 17.9319 14.5 18.8319 14.5 19.9319C14.5 21.0319 13.6 21.9319 12.5 21.9319C11.4 21.9319 10.5 21.0319 10.5 19.9319Z",
    fill: "#A0ADB6"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMore);
export default __webpack_public_path__ + "static/media/more.1f8485016166572b0d1b7a6e446eff3d.svg";
export { ForwardRef as ReactComponent };